import type { BackgroundTypes } from '@/types/contentstack';
import { sanitizeAttr, sanitizeCSS, sanitizeUrl } from '@utils/sanitizer';

const ID_PREFIX = 'social-link-header';

export interface HeaderParams {
  title: string;
  page_title: string;
  logo: {
    path: string;
    alt: string;
  };
  background: {
    effect: BackgroundTypes;
    color: string;
  };
}

const BACKGROUND_CLASS: Partial<Record<BackgroundTypes, string>> = {
  primary: 'ids-color-bg-brand-primary',
  secondary: 'ids-color-bg-brand-secondary',
  gradient: 'ids-color-bg-brand-gradient',
};

export function renderHeader(infos: HeaderParams): string {
  const effectClass = BACKGROUND_CLASS[infos.background.effect] ?? '';
  const customStyle =
    infos.background.effect === 'custom' && infos.background.color
      ? ` style="background: ${sanitizeCSS(infos.background.color)};"`
      : '';

  const headerClass = ['ids-py-6', effectClass].filter(Boolean).join(' ');

  const logo = infos.logo.path
    ? `
    <div class="ids-container" data-testid="${ID_PREFIX}-container">
      <h1 class="header__logo mh-auto" data-testid="${ID_PREFIX}-logo">
        <img src="${sanitizeUrl(infos.logo.path)}" alt="${sanitizeAttr(infos.logo.alt)}" data-testid="${ID_PREFIX}-image" />
      </h1>
    </div>`
    : '';

  return `
  <header class="${headerClass}"${customStyle} data-testid="${ID_PREFIX}">
    ${logo}
  </header>`;
}
